var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.eventUrl}},[_c('div',{staticClass:"event-microtile"},[_c('h3',[_vm._v(_vm._s(_vm.eventTitle))]),_c('img',{attrs:{"src":_vm.eventImage}})])])}
var staticRenderFns = []

export { render, staticRenderFns }